/**
 * @ignore
 *
 * App constants.
 */
export const EMAIL_REGEX = new RegExp('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$', 'i');
